import { PropsWithChildren } from 'react';

export function UserPreferencesProvider({ children }: PropsWithChildren) {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
